import Admin from '@/pages/Admin';

export const adminRoutes = [
  { path: "/admin", element: <Admin /> },
];